<template>
  <div>
    <b-alert
      v-for="(item, index) in imagenesList"
      :key="index"
      :variant="getVariantCard(item.action)"
      show
      class="my-1 p-2 position-relative card-imagenes"
    >
      <div 
        style="position: absolute; top: 10px; right: 12px; z-index: 10;"
      >
        <small class="text-muted mr-1">{{ item.action.toUpperCase() }}</small>
        <b-button 
          :variant="showCardComplete.includes(index) ? 'info' : ''" 
          size="sm" 
          class="card-button"
          @click="onViewItem(index)"
        >
          <i class="fa-solid fa-magnifying-glass"/>
        </b-button>

        <b-button
          v-if="canEditItem(item)"
          variant="warning" 
          size="sm"
          class="card-button"
          @click="onEditItem(index)"
        >
          <i class="fa-solid fa-pen"/>
        </b-button>

        <b-button 
          v-if="canDeleteItem(item)"
          variant="danger" 
          size="sm"
          class="card-button"
          @click="onRemoveItemList(index)"
        >
          <i class="fa-solid fa-x"/>
        </b-button>

        <b-button 
          v-if="item.action === 'eliminar'"
          variant="warning" 
          size="sm"
          class="card-button"
          @click="onRestoreItem(index)"
          title="Restaurar Item"
        >
          <i class="fa-solid fa-rotate-right"/>
        </b-button>
      </div>

      <b-row class="d-flex align-items-center" style="margin-bottom: 5px;">
        <strong class="item-label">Estado: </strong> 
        <span class="text-dark">{{ item.estadoImagen || '-' }}</span>
      </b-row>

      <b-row class="d-flex align-items-center" style="margin-bottom: 5px;">
        <strong class="item-label">Imagen: </strong> 
        <span class="text-dark">{{ item.imagen.text }}</span>
      </b-row>

      <b-row v-if="item.numeroPieza" class="d-flex align-items-center" style="margin-bottom: 5px;">
        <strong class="item-label">Número de Pieza: </strong> 
        <span class="text-dark">{{ item.numeroPieza }}</span>
      </b-row>

        <b-row v-if="item.textDiagnostico" class="d-flex align-items-center" style="margin-bottom: 5px;">
        <strong class="item-label">Diagnostico: </strong> 
        <span class="text-dark">{{ item.textDiagnostico }}</span>
      </b-row>

      <b-row class="d-flex align-items-center" style="margin-bottom: 5px;">
        <strong class="item-label">Lateralidad: </strong> 
        <span class="text-dark">{{ item.lateralidad.text }}</span>
      </b-row>

      <b-row class="d-flex align-items-center" style="margin-bottom: 5px;">
        <strong class="item-label">N° de orden: </strong> 
        <span class="text-dark">{{ item.numeroOrden }}</span>
      </b-row>

      <span v-if="showCardComplete.includes(index)">
        <b-row class="d-flex align-items-center" style="margin-bottom: 5px;">
          <strong class="item-label">Sedacion: </strong> 
          <span class="text-dark">{{ item.sedacion === '1' ? 'Si' : 'No' }}</span>
        </b-row>

        <b-row class="d-flex align-items-center" style="margin-bottom: 5px;">
          <strong class="item-label">Motivo: </strong> 
          <span class="text-dark">{{ item.motivoSolicitud }}</span>
        </b-row>

        <b-row class="d-flex align-items-center" style="margin-bottom: 5px;">
          <strong class="item-label">Res. Clinico: </strong> 
          <span class="text-dark">{{ item.resumenClinico }}</span>
        </b-row>

        <b-row class="d-flex align-items-center" style="margin-bottom: 5px;">
          <strong class="item-label">justificacion: </strong> 
          <span class="text-dark">{{ item.justificacion }}</span>
        </b-row>
      </span>
      
    </b-alert>
  </div>
</template>

<script>
export default {
  name: "CardImagenesEnviadas",

  props: {
    imagenesList: {
      type: Array,
      default: () => []
    },

    saveInState: {
      type: Function,
      default: () => {}
    },

    onlyView: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showCardComplete: []
    }
  },


  methods:{

    onViewItem(index) {
      const exists = this.showCardComplete.includes(index)

      this.showCardComplete = exists 
        ? this.showCardComplete.filter(item => item !== index)
        : [...this.showCardComplete, index];
    },


    onEditItem(index){
      this.navigateToQuery("editImage", index);  
    },


    getVariantCard(action){

      const variant = action === 'registrado' 
        ? 'success'
        : action === 'editar'
          ? 'warning'
          : action === 'eliminar'
            ? 'danger'
            : 'info';

      return variant;
    },


    async onRemoveItemList(index){

      const result = await this.$swal.fire({
        title: 'Eliminar',
        text: "Estas seguro de eliminar esta imagen?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Eliminar!',
        cancelButtonText: 'Cancelar',
      });

      if (!result.isConfirmed) return;

      if (this.imagenesList[index].action !== 'crear'){
        this.imagenesList[index].action = 'eliminar';
        return;
      }

      this.imagenesList.splice(index, 1)
    },

    onRestoreItem(index){
      this.imagenesList[index].action = 'registrado'
    },

    canEditItem(item){
      const estadoValido = item.estadoImagen !== 'Incompleto' && item.estadoImagen !== 'Terminada';
      return item.action !== 'eliminar' && estadoValido && !this.onlyView
    },

    canDeleteItem(item){
      const estadoValido = item.estadoImagen !== 'Incompleto' && item.estadoImagen !== 'Terminada';
      return item.action !== 'eliminar' && estadoValido && !this.onlyView
    },

    navigateToQuery(queryParam, valueQuery) {
      try {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            [queryParam]: valueQuery,
          },
        });
      } catch (error) {
        console.error("Error en la navegación:", error);
      }
    },
  }
}
</script>


<style>

.card-imagenes .item-label {
  width: 140px;
  margin-left: 10px;
}

.card-imagenes .card-button {
  margin-left: 8px;
  padding: 5px;
}
</style>
